import {createSelector} from "reselect";

const Contacts = (state) => state.contacts;

const getContactData = createSelector(
  Contacts,
  (contacts) => contacts.contactsData || {}
);

export const getContactsList = createSelector(
  getContactData,
  (contactsData) => contactsData?.results || []
);

export const getContactTotalCount = createSelector(
  getContactData,
  (contactsData) => contactsData?.total_count
);

export const getContactPaginationUrls = createSelector(
  getContactData,
  (contactsData) => ({
    prevUrl: contactsData?.previous,
    nextUrl: contactsData?.next,
  })
);

export const getContactModalStatus = createSelector(
  Contacts,
  (Contacts) => Contacts.contactModalStatus
);
